import { MuiAlert } from './components/MuiAlert';
import { MuiAutocomplete } from './components/MuiAutocomplete';
import { MuiCssBaseline } from './components/MuiCssBaseline';
import { MuiDataGrid } from './components/MuiDataGrid';
import { MuiDivider } from './components/MuiDivider';
import { MuiFormControlLabel } from './components/MuiFormControlLabel';
import { MuiFormHelperText } from './components/MuiFormHelperText';
import { MuiLinearProgress } from './components/MuiLinearProgress';
import { MuiMenu } from './components/MuiMenu';
import { MuiMenuItem } from './components/MuiMenuItem';
import { MuiOutlinedInput } from './components/MuiOutlinedInput';
import { MuiRadio } from './components/MuiRadio';
import { MuiSelect } from './components/MuiSelect';
import { MuiStepper } from './components/MuiStepper';
import { MuiSwitch } from './components/MuiSwitch';
import { MuiTab } from './components/MuiTab';
import { MuiTabs } from './components/MuiTabs';
import { MuiTextField } from './components/MuiTextField';
import { MuiToggleButton } from './components/MuiToggleButton';
import { MuiToggleButtonGroup } from './components/MuiToggleButtonGroup';
import { MuiTooltip } from './components/MuiTooltip';

const unlockTheme = {
  themeName: 'unlock',
  components: {
    MuiAutocomplete,
    MuiDataGrid,
    MuiSelect,
    MuiRadio,
    MuiSwitch,
    MuiCssBaseline,
    MuiTooltip,
    MuiTab,
    MuiTabs,
    MuiFormControlLabel,
    MuiAlert,
    MuiTextField,
    MuiOutlinedInput,
    MuiToggleButton,
    MuiToggleButtonGroup,
    MuiStepper,
    MuiMenu,
    MuiFormHelperText,
    MuiDivider,
    MuiLinearProgress,
    MuiMenuItem,
  },
};

export default unlockTheme;
